import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';
import { FirestoreService } from './firestore/firestore.service';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/combineLatest';
import 'rxjs/add/operator/mergeMap';

import { Globals, Ref } from '../globals';
import { Console } from '@angular/core/src/console';
import * as _ from 'lodash';
import { WarehouseService, WarehouseId } from './warehouse.service';

export interface Transaction {
  folio: string;
  createdAt: any;
  date: string;
  type: TranType;
  inOutId: any;
  warehouseId: any;
  observations: string;
  prInTransaction?: PrInTransaction[];
  productionOrderRef?: any;
  billFolio?: string;
  billRef?: Ref;
  remRef?: Ref;
  canceled: boolean;
  cancelReasons: {datetime: string, msg: string}[];
}


export interface TransactionId extends Transaction {
  id: string;
  warehouseObj?: WarehouseId;
}

export interface PrInTransaction {
  ref: any;
  quantity: number;
  cost: number;
  odpId: string;
  odpName: string;
  odcId: string;
  odcIndex?: number;
}

@Injectable()
export class TranService {

  transactionCollection: AngularFirestoreCollection<Transaction>;
  transactions: any;

  transactionDocument: AngularFirestoreDocument<Transaction>;

  collection: string;
  warehouseRef: string;
  inOutIdRef: string;
  prCmpaCollection: string;
  prVntaCollection: string;
  productionOrderCollection: string;
  billCollection: string;
  remCollection: string;

  // NOTE: Change this any for Transaction Interface
  transaction$: Observable<any>;
  warehouse$: Observable<any>;

  constructor(
    private afs: AngularFirestore,
    public afh: FirestoreService,
    private router: Router,
    private warehouseService: WarehouseService
  ) {
    this.collection = Globals.TRANSACTION_COLLECTION;
    this.warehouseRef = Globals.WAREHOUSE_COLLECTION;
    this.inOutIdRef = Globals.IN_AND_OUT_COLLECTION;
    this.prCmpaCollection = Globals.PRCMPA_COLLECTION;
    this.prVntaCollection = Globals.PRVNTA_COLLECTION;
    this.productionOrderCollection = Globals.PRODUCTION_ORDER_COLLECTION;
    this.billCollection = Globals.CUSTOMER_BILL_COLLECTION;
    this.remCollection = Globals.REMISSION_COLLECTION;
  }

  /**
   * Get all transactions with references
   * @return {Observable} Arrays of transactions
   */
  getTransactions({fromDate=''} = {}) {
    let col;
    if(!fromDate){
      col = this.afh.colWithIds$(this.collection, ref => ref.orderBy('date','desc'));
    }else{
      col = this.afh.colWithIds$(this.collection, ref => ref.orderBy('date','desc').where('date', '>=', fromDate));
    }
    return col.map(documents => {
      return documents.map((document: Transaction) => {
        /* if(!document.productionOrderRef){ */
          return Observable.combineLatest(
            this.afh.docWithIds$(document.warehouseId.path),
            this.afh.docWithIds$(`${document.inOutId.path}`),
            (warehouseData, inTypeData) => ({ warehouse: warehouseData, inType: inTypeData })
          ).map(data => ({ warehouseObj: data.warehouse, inOutTypeObj: data.inType, ...document }) );
        /* }else{
          return Observable.combineLatest(
            this.afh.docWithIds$(document.warehouseId.path),
            this.afh.docWithIds$(`${document.inOutId.path}`),
            this.afh.docWithIds$(`${document.productionOrderRef.path}`),
            (warehouseData, inTypeData, productionOrderData) => ({ warehouse: warehouseData, inType: inTypeData, productionOrder: productionOrderData })
          ).map(data => ({ warehouseObj: data.warehouse, inOutTypeObj: data.inType, productionOrderObj: data.productionOrder, ...document }) );
        } */
      });
    })
    .mergeMap(transactionDocuments => Observable.combineLatest(transactionDocuments));
  }

  getTransaction(id: string){
    return this.afh.doc$(`${this.collection}/${id}`).flatMap((document: Transaction) => {
      /* if(!document.productionOrderRef){ */
        return Observable.combineLatest(
          this.afh.docWithIds$(document.warehouseId.path),
          this.afh.docWithIds$(`${document.inOutId.path}`),
          (warehouseData, inTypeData) => ({ warehouse: warehouseData, inType: inTypeData })
        ).map(data => ({ warehouseObj: data.warehouse, inOutTypeObj: data.inType, ...document }) );
      /* }else{
        return Observable.combineLatest(
          this.afh.docWithIds$(document.warehouseId.path),
          this.afh.docWithIds$(`${document.inOutId.path}`),
          this.afh.docWithIds$(`${document.productionOrderRef.path}`),
          (warehouseData, inTypeData, productionOrderData) => ({ warehouse: warehouseData, inType: inTypeData, productionOrder: productionOrderData })
        ).map(data => ({ warehouseObj: data.warehouse, inOutTypeObj: data.inType, productionOrderObj: data.productionOrder, ...document }) );
      } */
    })
  }


  /**
  * Create new transaction
  * @param {Transactions} transaction - The data of the transaction
  */
  addTransaction({productionOrderRef, ...transaction}, tranType: TranType) {
    transaction.warehouseId = this.afh.doc(`${this.warehouseRef}/${transaction.warehouseId}`).ref;
    transaction.inOutId = this.afh.doc(`${this.inOutIdRef}/${transaction.inOutId}`).ref;
    //transaction.productionOrderRef = productionOrderRef ? this.afh.doc(`${this.productionOrderCollection}/${productionOrderRef}`).ref : '';
    transaction.type = tranType;
    this.afh.add(`${this.collection}`, transaction);
    this.warehouseService.updateWarehouseProducts(transaction.warehouseId.id, transaction.prInTransaction);
    if(tranType == TranType.In) this.router.navigate(['/in_tran']);
    else this.router.navigate(['/out_tran']);
  }

}

export enum TranType {
  In,
  Out
}